import { render, staticRenderFns } from "./ViewPDF.vue?vue&type=template&id=b89fd75c&scoped=true&"
import script from "./ViewPDF.vue?vue&type=script&lang=js&"
export * from "./ViewPDF.vue?vue&type=script&lang=js&"
import style0 from "./ViewPDF.vue?vue&type=style&index=0&id=b89fd75c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89fd75c",
  null
  
)

export default component.exports